(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["guuds-choice-tools"] && !Shopify.designMode) return;
  try {
    function initializeGuudsChoice(scope=document){
  scope.querySelectorAll('[data-guuds-choice]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const form=root.querySelector('[data-choice-form]');
    const result=root.querySelector('[data-result]');
    root.querySelector('[data-quiz]').hidden=false;
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const values=new FormData(form);
      const selected=[values.get('cleanser'),values.get('cream')];
      if(values.get('steps')==='three')selected.push('onyx');
      root.querySelectorAll('[data-recommendation]').forEach(card=>{card.hidden=!selected.includes(card.dataset.recommendation)});
      result.hidden=false;
      result.querySelector('h4').focus();
      root.dispatchEvent(new CustomEvent('guuds:ritual-change',{bubbles:true}));
    });
    form.addEventListener('change',()=>{result.hidden=true});
    root.querySelector('[data-reset]').addEventListener('click',()=>{
      result.hidden=true;
      form.querySelector('input').focus();
    });
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeGuudsChoice());else initializeGuudsChoice();
document.addEventListener('shopify:section:load',event=>initializeGuudsChoice(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["guuds-help-center"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-guuds-help]').forEach(function(root){
 const tools=root.querySelector('.guuds-help-tools'),input=root.querySelector('[data-help-search]'),buttons=root.querySelectorAll('[data-help-filter]'),groups=root.querySelectorAll('[data-help-group]'),empty=root.querySelector('.guuds-help-empty');let category='all';
 tools.hidden=false;
 const normalize=function(s){return s.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim()};
 const update=function(){const query=normalize(input.value),words=query.split(/\s+/).filter(Boolean);let total=0;groups.forEach(function(group){let count=0;group.querySelectorAll('details').forEach(function(row){const content=normalize(row.textContent),match=(category==='all'||category===group.dataset.helpGroup)&&words.every(function(word){return content.includes(word)});row.hidden=!match;if(match){count++;total++}});group.hidden=count===0});empty.hidden=total>0};
 input.addEventListener('input',update);buttons.forEach(function(button){button.addEventListener('click',function(){category=button.dataset.helpFilter;buttons.forEach(function(b){b.setAttribute('aria-pressed',String(b===button))});update()})});
});
  } catch(e) { console.error(e); }
})();

})();
